export const parseURLParams = (url: string): Record<string, (string | null)[]> | undefined => {
    const queryStart = url.indexOf('?') + 1,
        queryEnd = url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        queryClean = query.replace('amp;', ''),
        pairs = queryClean.replace(/\+/g, ' ').split('&'),
        params: Record<string, (string | null)[]> = {};
    let i, n, v, nv;

    if (query === url || query === '') return;

    for (i = 0; i < pairs.length; i++) {
        nv = pairs[i].split('=', 2);
        n = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]);

        if (!params.hasOwnProperty(n)) params[n] = [];
        params[n].push(nv.length === 2 ? v : null);
    }
    return params;
};
